import React from 'react';
import { ButtonView } from '@vivli/shared/views';
import { buttonIconStyle, buttonStyle } from './button.styles';
import { AssetsConstant } from '@vivli/shared/infrastructure/constants';

export const InfoButtonView = ({ onClick }) => (
    <ButtonView style={buttonStyle} onClick={onClick} className="search_instructions" dataId="search-info-button">
        <img src={AssetsConstant.INFO_BANG} style={{ ...buttonIconStyle, width: '40px' }} />
    </ButtonView>
);
